<template>



  <a :href="href" :class="classes" v-if="as =='a'">
    <slot></slot>
  </a>
  <inertia-link :href="href" :class="classes" v-else>
    <slot></slot>
  </inertia-link>


</template>

<script>
export default {
  props: ['href', 'active', 'as'],

  computed: {
    classes() {
      return this.active
          ? 'text-black text-md font-bold inline-flex items-center px-1 pt-1 border-b-2 border-indigo-400 font-medium leading-5 text-gray-900 focus:outline-none focus:border-indigo-700 transition'
          : 'text-gray-600 text-md font-bold inline-flex items-center px-1 pt-1 border-b-2 border-transparent font-medium leading-5 text-gray-500 hover:text-gray-900 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition'
    }
  }
}
</script>
